// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.batch-modal-wrapper-box {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.batch-header {
  display: flex;
  flex-direction: column;
}

.batch-header-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.batch-header-title {
  font-weight: 600 !important;
  line-height: 1 !important;
  color: var(--blue) !important;
}

.batch-header-subtitle {
  color: grey;
}

.batch-header-title-box {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.batch-header-title-text-box {
  display: flex;
  flex-direction: column;
}

.batch-header-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  border: 1px solid #dbdbdb;
}

.select-button-box {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}

.batch-select-text {
  color: gray;
  font-size: 0.8rem;
}

.batch-select-batchno {
  font-weight: bold;
}

.select-batch-wrapper-box {
  padding: 5px;
  display: flex;
  align-items: center;
  gap: 15px;
  border-radius: 7px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}

.batch-option-wrapper-box {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

/* ── Dark theme ── */
.dark .batch-header-icon {
  border-color: #334155;
}

.dark .batch-header-subtitle {
  color: #64748b;
}

.dark .batch-select-text {
  color: #94a3b8;
}

.dark .select-batch-wrapper-box {
  background-color: #1e293b;
  box-shadow: rgba(0, 0, 0, 0.4) 0px 7px 29px 0px;
}

.dark .batch-header-title {
  color: #93c5fd !important;
}

.dark .batch-select-batchno {
  color: #f1f5f9;
}

.dark .batch-modal-wrapper-box {
  background-color: #1e293b;
}

.dark .batch-option-wrapper-box {
  background-color: #1e293b;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/delivery/components/ValidationModal/BatchModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".batch-modal-wrapper-box {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.batch-header {\n  display: flex;\n  flex-direction: column;\n}\n\n.batch-header-box {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.batch-header-title {\n  font-weight: 600 !important;\n  line-height: 1 !important;\n  color: var(--blue) !important;\n}\n\n.batch-header-subtitle {\n  color: grey;\n}\n\n.batch-header-title-box {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.batch-header-title-text-box {\n  display: flex;\n  flex-direction: column;\n}\n\n.batch-header-icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 35px;\n  height: 35px;\n  border-radius: 50%;\n  border: 1px solid #dbdbdb;\n}\n\n.select-button-box {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n}\n\n.batch-select-text {\n  color: gray;\n  font-size: 0.8rem;\n}\n\n.batch-select-batchno {\n  font-weight: bold;\n}\n\n.select-batch-wrapper-box {\n  padding: 5px;\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  border-radius: 7px;\n  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n}\n\n.batch-option-wrapper-box {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n/* ── Dark theme ── */\n.dark .batch-header-icon {\n  border-color: #334155;\n}\n\n.dark .batch-header-subtitle {\n  color: #64748b;\n}\n\n.dark .batch-select-text {\n  color: #94a3b8;\n}\n\n.dark .select-batch-wrapper-box {\n  background-color: #1e293b;\n  box-shadow: rgba(0, 0, 0, 0.4) 0px 7px 29px 0px;\n}\n\n.dark .batch-header-title {\n  color: #93c5fd !important;\n}\n\n.dark .batch-select-batchno {\n  color: #f1f5f9;\n}\n\n.dark .batch-modal-wrapper-box {\n  background-color: #1e293b;\n}\n\n.dark .batch-option-wrapper-box {\n  background-color: #1e293b;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
